<template>
  <div
    class="sliderContainer"
    uk-slideshow="animation: fade; autoplay: true; autoplay-interval: 4000; pause-on-hover: false">
    <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1">
      <ul class="uk-slideshow-items">
        <li v-for="(item, index) in slideItems" :key="index">
          <div
            class="uk-position-cover uk-transform-origin-center-left">
            <img :src="`${ASSETS_BASE_URL}${item.img_path}`" alt="" uk-cover>
          </div>
        </li>
      </ul>
      <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#"
         uk-slidenav-previous
         uk-slideshow-item="previous"></a>
      <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#"
         uk-slidenav-next
         uk-slideshow-item="next"></a>
    </div>
    <ul class="uk-slideshow-nav uk-dotnav uk-flex-center uk-margin"></ul>
  </div>
</template>

<script>
export default {
  name: 'SliderComponent',
  props: [
    'slideItems'
  ]
}
</script>

<style>
  .sliderContainer {
    margin-top: -60px;
  }

  @media only screen and (max-width: 1199px) {
    .sliderContainer {
      margin-top: -80px;
    }
  }

  .sliderContainer .uk-slideshow-items {
    min-height: auto !important;
    height: 100vh !important;
  }

  .sliderContainer .uk-slideshow-items > li > div {
    width: 100% !important;
    background: #fff;
  }

  .sliderContainer .uk-slidenav-previous,
  .sliderContainer .uk-slidenav-next {
    color: #000 !important;
  }
</style>
